import script from "./SidenavList.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavList.vue?vue&type=script&setup=true&lang=js"

import "./SidenavList.vue?vue&type=style&index=0&id=1cc3543c&lang=css"

const __exports__ = script;

export default __exports__